import { CompaniesList } from '@/app/components/features/companies/CompaniesList';
import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/_authed/(organization)/_layout/settings/_layout/clients')({
  component: RouteComponent,
});

function RouteComponent() {
  return <CompaniesList />;
}
